/**
 * Change Password Controller
 * @param $scope
 * @param $state {ui.IStateService}
 * @param $mdDialog
 * @param MKioskService {MKioskService}
 * @param $message
 * @param $Loading
 * @param $translationService
 * @param $timeout {angular.ITimeoutService}
 * @param $ionicPopup {$ionicPopup}
 * @param mdPanelRef {MdPanelRef}
 * @param mustUpdatePasswordReason{string}
 * @constructor
 */
function ChangePasswordController($scope, $state, $mdDialog, MKioskService, $message, $Loading, $translationService, $timeout, $ionicPopup
    , mdPanelRef, mustUpdatePasswordReason) {
    this.$scope = $scope;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.MKioskService = MKioskService;
    this.$message = $message;
    this.$Loading = $Loading;
    this.$translationService = $translationService;
    this.$timeout = $timeout;
    this.$ionicPopup = $ionicPopup;


    this.isPasswordWeak = false;
    // this.messagePasswordTooWeak = this.$message.get("PasswordTooWeak");
    this.currentLogin = null;

    this.mdPanelRef = mdPanelRef;
    this.mustUpdatePasswordReason = mustUpdatePasswordReason;
    this.hasReason = (mustUpdatePasswordReason !== undefined && mustUpdatePasswordReason !== null);

    this.oldPassword = null;
    this.visibleOldPassword = false;
    
    this.newPassword = null;
    
    /** @type {('Weak'|'Medium'|'Strong'|null)} */
    this.passwordStrength = null;  // Password strength
    
    this.invalidOldPassword = false; // For invalid old password
    this.invalidCannotReuseTheOldPassword = false; // For cannot reuse the old password


    // NF-607
    MKioskService.getCurrentUser().then((login) => {
        this.currentLogin = login;
    }, $message.error)
}


ChangePasswordController.prototype = {
    // isPasswordWeak: false,
    /**
     * Close dialog
     */
    closeDialog() {
        return this.mdPanelRef.close();
    },

    /**
     * Generate password
     */
    generatePassword() {
        this.MKioskService.generatePass().then( (newPassword)=> {
            this.newPassword = newPassword;
            this.onChangeNewPassword();
        });
    },

    /**
     * Check the strength of password
     */
    onChangeNewPassword() {
        this.invalidCannotReuseTheOldPassword = false; // Reset cannot reuse the old password error
        
        if (this.newPassword) {
            this.MKioskService.estimatePasswordStrength(this.newPassword).then( (passwordStrengthNumber)=> {
                this.passwordStrength = passwordStrengthNumber;
            }).finally(()=>{
                this.validNewPassword();
            });
        } else {
            this.passwordStrength = null; 
            this.validNewPassword();
        }
    },
    
    /**
     * Save form to server and after that submit
     * @param changepasswordform {angular.IFormController}
     */
    save(changepasswordform) {
        // Set form to submitted state, to show validation errors
        changepasswordform.$setSubmitted();
        
        // If form is invalid, do nothing
        if(changepasswordform.$invalid){
            return;
        }
   
            
        this.$Loading.show({
            title: "Changing password"
        });
        let data = {
            NewPassword: this.newPassword
        }
        if (!this.hasReason) {
            data.OldPassword = this.oldPassword
        }
        this.MKioskService.changePassword(data).then(() => {
            this.showUpdatedPasswordMessage().then(()=>{
                this.$timeout( () => { // have to use timeout to trigger hidden form submit (prevent form submit)
                    $('#change-password-modal').find(".btn-submit").trigger("click");
                }, 0, false);
            });
  
        }, (error) => {
            if (error.data && error.data.code === "PasswordTooWeak") { // Show weak password message
                this.passwordStrength = "Weak";
                this.validNewPassword();
                return; // Do not show error message
            }
            if (error.data && error.data.code === "InvalidOldPassword") { // Show weak password message
                this.invalidOldPassword = true;
                this.validOldPassword();
                return; // Do not show error message
            }
            if (error.data && error.data.code === "CannotReuseTheOldPassword") { // Show weak password message
                this.invalidCannotReuseTheOldPassword = true;
                this.validNewPassword();
                return; // Do not show error message
            }
            
            this.$message.error(error);
        }).finally(() => {
            this.$Loading.hide();
        });
    },

    /**
     * Show messages after updated password
     * @returns {Promise}
     */
    showUpdatedPasswordMessage() {
        return this.$ionicPopup.alert({
            cssClass:'change-password-updated-success',
            template: this.$translationService.getTranslation('YourPasswordHasBeenUpdated'),
            okText: this.$translationService.getTranslation('OK')
        });

    },

    /**
     * On hidden form submit
     */
    submit() {
        this.reload().then(()=>{
            this.closeDialog();
        })
    },

    reload() {
        return this.$state.go('internal.empty').then(() => {
            return this.$state.go('internal.home');
        });
    },
    
    // Don't submit when press enter
    preventSubmitOnEnter($event){
        let isEnter = $event.key === 'Enter' || $event.keyCode === 13;
        if (isEnter) {
            // **Stop the default browser action (form submission)**
            $event.preventDefault();

        }
    },

    
    toggleVisibleOldPassword(name){
        let $input = $("#" + name);
        this.visibleOldPassword = !this.visibleOldPassword;
        $input.attr("type", (this.visibleOldPassword ? "text" : "password"));
    },

    /**
     * Set validity for new password
     */
    validNewPassword(){
        // Validate weak password
        if(this.newPassword){
            this.$scope.changepasswordform.newPassword.$setValidity('isPasswordWeak', (this.passwordStrength === 'Medium' || this.passwordStrength === 'Strong'));
        } else {
            this.$scope.changepasswordform.newPassword.$setValidity('isPasswordWeak', true);
        }
      
        // Validate cannot reuse the old password
        this.$scope.changepasswordform.newPassword.$setValidity('invalidCannotReuseTheOldPassword', this.invalidCannotReuseTheOldPassword === false);
    },
    
    /**
     * On change old password, reset invalid state
     */
    onChangeOldPassword(){
        this.invalidOldPassword = false;
        this.validOldPassword();
    },

    /**
     * Set validity for invalid old password
     */
    validOldPassword(){
        this.$scope.changepasswordform.oldPassword.$setValidity('invalidOldPassword', this.invalidOldPassword === false);
    }
}


ChangePasswordController.$inject = ['$scope', '$state', '$mdDialog', 'MKioskService', '$message', '$Loading', '$translationService', '$timeout','$ionicPopup',  'mdPanelRef', 'mustUpdatePasswordReason'];

angular.module('internal.changepassword', []).controller('ChangePasswordController', ChangePasswordController);
